import _default from './Pagination';
export { _default as default };